/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Review_Success_QuestionInputs */

const en_ticket_review_success_question = /** @type {(inputs: Ticket_Review_Success_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was the activity successfully completed?`)
};

const ja_ticket_review_success_question = /** @type {(inputs: Ticket_Review_Success_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業は正常に完了しましたか？`)
};

const fr_ticket_review_success_question = /** @type {(inputs: Ticket_Review_Success_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'activité a-t-elle été menée à bien ?`)
};

const de_ticket_review_success_question = /** @type {(inputs: Ticket_Review_Success_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wurde die Aktivität erfolgreich abgeschlossen?`)
};

/**
* | output |
* | --- |
* | "Was the activity successfully completed?" |
*
* @param {Ticket_Review_Success_QuestionInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_review_success_question = /** @type {((inputs?: Ticket_Review_Success_QuestionInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Review_Success_QuestionInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_review_success_question(inputs)
	if (locale === "ja") return ja_ticket_review_success_question(inputs)
	if (locale === "fr") return fr_ticket_review_success_question(inputs)
	return de_ticket_review_success_question(inputs)
});